<div class="presentacion-inicial-container">
    <div class="header-section">
        <h1 class="page-title">
            <i class="bi bi-cloud-upload-fill"></i>
            Presentación Inicial de Documentos
        </h1>
        <p class="page-description">
            Sube los documentos necesarios para iniciar tu trámite de evaluación de salud irrecuperable.
            Solo se aceptan archivos PDF o ZIP.
        </p>
    </div>
    <!-- Info Section -->
    <div class="info-section">
        <div class="info-card">
            <i class="bi bi-info-circle-fill"></i>
            <div>
                <h5>Información importante</h5>
                <ul>
                    <li>Solo se aceptan archivos en formato PDF o ZIP</li>
                    <li>El tamaño máximo por archivo es de 20MB</li>
                    <li>Puedes subir hasta {{ maxFiles }} archivos a la vez</li>
                    <li>Asegúrate de que los documentos sean legibles y estén completos</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="upload-card">
        <!-- Drag and Drop Area -->
        <div class="drop-zone" [class.dragging]="isDragging" (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" (click)="fileInput.click()">

            <div class="drop-zone-content">
                <i class="bi bi-cloud-arrow-up drop-icon"></i>
                <h3 class="drop-title">Arrastra tus archivos aquí</h3>
                <p class="drop-text">o haz clic para seleccionar</p>
                <div class="file-types">
                    <span class="badge badge-pdf">
                        <i class="bi bi-file-pdf"></i> PDF
                    </span>
                    <span class="badge badge-zip">
                        <i class="bi bi-file-zip"></i> ZIP
                    </span>
                </div>
                <small class="text-muted">Máximo {{ maxFiles }} archivos • Tamaño máximo 20MB por archivo</small>
            </div>

            <input #fileInput type="file" [accept]="accept" multiple (change)="onFileSelect($event)"
                style="display: none;">
        </div>

        <!-- File List -->
        <div *ngIf="selectedFiles.length > 0" class="file-list">
            <div class="file-list-header">
                <h4>
                    <i class="bi bi-files"></i>
                    Archivos seleccionados ({{ selectedFiles.length }}/{{ maxFiles }})
                </h4>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="clearAll()">
                    <i class="bi bi-trash"></i> Limpiar todo
                </button>
            </div>

            <div class="files-grid">
                <div *ngFor="let file of selectedFiles; let i = index" class="file-item">
                    <div class="file-icon" [style.color]="getFileIconColor(file.name)">
                        <i class="bi" [ngClass]="getFileIcon(file.name)"></i>
                    </div>
                    <div class="file-info">
                        <div class="file-name" [title]="file.name">{{ file.name }}</div>
                        <div class="file-size">{{ formatFileSize(file.size) }}</div>
                    </div>
                    <button type="button" class="btn-remove" (click)="removeFile(i)" title="Eliminar archivo">
                        <i class="bi bi-x-circle-fill"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Upload Progress -->
        <div *ngIf="isUploading" class="upload-progress">
            <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                    [style.width.%]="uploadProgress" [attr.aria-valuenow]="uploadProgress" aria-valuemin="0"
                    aria-valuemax="100">
                    {{ uploadProgress }}%
                </div>
            </div>
            <p class="text-center mt-2 text-muted">Subiendo archivos...</p>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
            <button type="button" class="btn btn-primary btn-lg" (click)="onSubmit()"
                [disabled]="selectedFiles.length === 0 || isUploading">
                <i class="bi bi-upload"></i>
                Subir Documentos
            </button>
            <button type="button" class="btn btn-outline-secondary btn-lg" routerLink="/inicio"
                [disabled]="isUploading">
                <i class="bi bi-arrow-left"></i>
                Volver
            </button>
        </div>
    </div>


</div>